<template>
  <div>
    <div v-if="loadingItem" class="text-center mt-5 pt-5">
      <loading-animation />
    </div>

    <b-row v-else>
      <div class="col mb-3 mt-n1">
        <div class="row mx-md-n3 mx-0">
          <div class="col-xl-1 col-lg-3 col-md-3 col-12">
            <div class="row">
              <div class="col-xl-12 col-sm-auto col-12">
                <small>Empresa:</small>
              </div>
              <div class="col-xl-12 col-sm col-12">
                <h5>{{ getEmpresaCodigoFromRef(item.ref) }}</h5>
              </div>
            </div>
          </div>
          <div class="col-xl-2 col-lg-3 col-md-3 col-12">
            <div class="row">
              <div class="col-xl-12 col-sm-auto col-12">
                <small>Reduzido:</small>
              </div>
              <div class="col-xl-12 col-sm col-12">
                <h5>{{ getItemReduzidoFromRef(item.ref) }}</h5>
              </div>
            </div>
          </div>

          <div class="col-xl-2 col-lg-3 col-md-3 col-12">
            <div class="row">
              <div class="col-xl-12 col-sm-auto col-12">
                <small>Referência:</small>
              </div>
              <div class="col-xl-12 col-sm col-12">
                <h5>{{ item.sku }}</h5>
              </div>
            </div>
          </div>
          <div class="col-xl-7 col-12">
            <div class="row">
              <div class="col-xl-12 col-sm-auto col-12">
                <small>Descrição:</small>
              </div>
              <div class="col-xl-12 col-sm col-12">
                <h5>{{ item.description }}</h5>
              </div>
            </div>
          </div>
          <div class="col-xl col-md col-12">
            <div class="row">
              <div class="col-xl-12 col-sm-auto col-12">
                <small>Código de barras:</small>
              </div>
              <div class="col-xl-12 col-md-auto col-sm-6 col-12">
                <h5>{{ item.gtin }}</h5>
              </div>
            </div>
          </div>
          <div class="col-md-auto col-4">
            <div class="row">
              <div class="col-xl-12 col-sm-auto col-12">
                <small>Total Alocado:</small>
              </div>
              <div class="col-xl-12 col-md-auto col-sm-6 col-12">
                <h5>{{ item.totalAllocated }}</h5>
              </div>
            </div>
          </div>
          <div class="col-md-auto col-4">
            <div class="row">
              <div class="col-xl-12 col-sm-auto col-12">
                <small>Endereços:</small>
              </div>
              <div class="col-xl-12 col-sm col-12">
                <h5>{{ item.totalAllocations }}</h5>
              </div>
            </div>
          </div>
          <div class="col-md-auto col-4">
            <div class="row">
              <div class="col-xl-12 col-sm-auto col-12">
                <small>Capacidade total:</small>
              </div>
              <div class="col-xl-12 col-sm col-12">
                <h5>{{ item.totalCapacity }}</h5>
              </div>
            </div>
          </div>
        </div>
      </div>

      <b-tabs pills card lazy class="col-12" v-model="tabIndex">
        <b-tab @click="tabChangedToWarehouses">
          <template slot="title">
            <i class="fa fa-cube"> Armazéns</i>
          </template>

          <item-warehouses
            ref="itemWarehousesTab"
            :item="item"
            :updateItem="updateItem"
          />
        </b-tab>

        <b-tab @click="tabChangedToLocations">
          <template slot="title">
            <i class="fa fa-cube"> Endereços</i>
          </template>

          <item-locations
            ref="itemLocationsTab"
            :item="item"
            :loadingWarehouses="loadingWarehouses"
            :warehouses="warehouses"
            :alwaysTrueFilterPredicate="alwaysTrueFilterPredicate"
            :updateItem="updateItem"
            :locationsSearchedCallback="locationsSearchedCallback"
            :lotsFilter="lotsFilter"
            :searchLots="searchLots"
          />
        </b-tab>

        <b-tab @click="tabChangedToLots">
          <template slot="title">
            <i class="fa fa-barcode"> Lotes</i>
          </template>

          <item-lots
            ref="itemLotsTab"
            :item="item"
            :loadingWarehouses="loadingWarehouses"
            :warehouses="warehouses"
            :alwaysTrueFilterPredicate="alwaysTrueFilterPredicate"
            :isUserManager="isUserManager"
            :searchLocations="searchLocations"
            :lotsSearchedCallback="lotsSearchedCallback"
            :locationsFilter="locationsFilter"
          />
        </b-tab>

        <b-tab @click="tabChangedToBalances">
          <template slot="title">
            <i class="fa fa-cubes"> Estoques</i>
          </template>

          <item-balances
            ref="itemBalancesTab"
            :item="item"
            :loadingWarehouses="loadingWarehouses"
            :warehouses="warehouses"
            :alwaysTrueFilterPredicate="alwaysTrueFilterPredicate"
            :locationsFilter="locationsFilter"
            :lotsFilter="lotsFilter"
            :searchLocations="searchLocations"
            :searchLots="searchLots"
          />
        </b-tab>

        <b-tab @click="tabChangedToHistory">
          <template slot="title">
            <i class="fa fa-history"> Histórico</i>
          </template>

          <item-movements
            ref="itemMovementsTab"
            :item="item"
            :loadingWarehouses="loadingWarehouses"
            :warehouses="warehouses"
            :alwaysTrueFilterPredicate="alwaysTrueFilterPredicate"
            :locationsFilter="locationsFilter"
            :lotsFilter="lotsFilter"
            :searchLocations="searchLocations"
            :searchLots="searchLots"
            :updateItem="updateItem"
          />
        </b-tab>

        <b-tab @click="tabChangedToComposition">
          <template slot="title">
            <i class="fa fa-sitemap"> Composição</i>
          </template>

          <item-composition
            ref="itemCompositionTab"
            :item="item"
            :getItemReduzidoFromRef="getItemReduzidoFromRef"
          />
        </b-tab>
      </b-tabs>
    </b-row>

  </div>
</template>

<script>
  import LineChart from '@/components/charts/line-charts'
  import TableHistoryItem from '@/components/tables/table-history-item'
  import { httpClient } from '@/service';
  import shared from '@/shared/shared'
  import { LoadingAnimation } from '@/components/loaders'
  import { ModelListSelect } from 'vue-search-select'
  import ItemWarehouses from '@/views/warehouse/item/tabs/item-warehouses';
  import ItemLocations from '@/views/warehouse/item/tabs/item-locations';
  import ItemLots from '@/views/warehouse/item/tabs/item-lots';
  import ItemBalances from '@/views/warehouse/item/tabs/item-balances';
  import ItemMovements from '@/views/warehouse/item/tabs/item-movements';
  import ItemComposition from '@/views/warehouse/item/tabs/item-composition';
  import { auth } from "@/service";

  const TAB_INDEXES = {
    WAREHOUSES: 0,
    LOCATIONS: 1,
    LOTS: 2,
    BALANCES: 3,
    HISTORY: 4,
    COMPOSITION: 5
  }

  export default {
    name: 'item-show',
    components: {
      TableHistoryItem,
      LineChart,
      LoadingAnimation,
      ModelListSelect,
      ItemWarehouses,
      ItemLocations,
      ItemLots,
      ItemBalances,
      ItemMovements,
      ItemComposition
    },

    props: {
      itemId: {
        type: String,
        default: null
      },
      isModal: {
        type: Boolean,
        default: false
      }
    },

    data () {
      return {
        item: {
          name: '',
          itemLotMovements: []
        },
        url: '',
        locationSearchTimeout: null,
        lotSearchTimeout: null,
        loadingWarehouses: false,
        warehouses: [],
        warehousesSearched: false,
        loadingItem: false,
        isUserManager: false,
        authUser: null,
        locationsFilter: {
          loading: false,
          locations: [],
        },
        lotsFilter: {
          loading: false,
          lots: [],
        },
        tabIndex: 0,
        scrollableElement: undefined
      }
    },

    mounted() {
      //const { all:{ href: url } } = localStorage.getItem('endpoints/historyItem');
      //this.url = url.replace('{UUID}', this.item.id)
      this.authUser = shared.getAuthUser();
      this.setIsUserManager();
      this.listenToScrollBottom();

      if (!this.isModal) {
        this.findItem(this.$route.params.id);
      }
    },

    beforeDestroy() {
      if (this.scrollableElement) {
        this.scrollableElement.removeEventListener('scroll', this.onScroll);
      }
    },

    computed: {
      currentTab() {
        switch (this.tabIndex) {
          case TAB_INDEXES.WAREHOUSES:
            return this.$refs.itemWarehousesTab;
          case TAB_INDEXES.LOCATIONS:
            return this.$refs.itemLocationsTab;
          case TAB_INDEXES.LOTS:
            return this.$refs.itemLotsTab;
          case TAB_INDEXES.BALANCES:
            return this.$refs.itemBalancesTab;
          case TAB_INDEXES.HISTORY:
            return this.$refs.itemMovementsTab;
          case TAB_INDEXES.COMPOSITION:
            return this.$refs.itemCompositionTab;
        }

        return null;
      },

      allTabs() {
        return [
          this.$refs.itemWarehousesTab,
          this.$refs.itemLocationsTab,
          this.$refs.itemLotsTab,
          this.$refs.itemBalancesTab,
          this.$refs.itemMovementsTab,
          this.$refs.itemCompositionTab
        ]
      }
    },

    methods: {
      findItem(itemId) {
        this.loadingItem = true;
        httpClient.get(`${process.env.VUE_APP_API_URL}items/${itemId}/with-quantity/with-count-and-max`)
        .then(data => {
          this.loadingItem = false;
          this.item = data.data.data;

          if (this.item) {
            this.$nextTick(() => {
              if (!this.warehousesSearched) {
                this.getWarehouses();
                this.warehousesSearched = true;
              }
              this.currentTab.tabChanged();
            });
          }
        }).catch(error => {
          this.loadingItem = false;
          if (error.message) {
            this.$notify.error(error)
          } else {
            this.$notify.textError("Houve um erro ao buscar o item");
          }
        });
      },

      getWarehouses() {
        if (this.loadingWarehouses) {
          return;
        }

        this.loadingWarehouses = true;
        httpClient
        .post(`${process.env.VUE_APP_API_URL}stock-locales/condition?page=${0}&size=${100}`, {
          conditions: [
            {
              logicalOperator: 'OR',
              conditions: [
                {
                  joinType: 'LEFT',
                  field: 'locations.item.id',
                  value: this.item.id
                },
                {
                  joinType: 'LEFT',
                  field: 'locations.balances.itemLot.item.id',
                  value: this.item.id
                }
              ]
            },
            {
              field: 'active',
              value: true
            }
          ],
          groupBy: [
            'id'
          ]
        })
        .then(({ data }) => {
          this.loadingWarehouses = false;
          this.warehouses = data.data.content;

          if (this.warehouses) {
            this.warehouses.unshift({id: null, name: 'Todos'});
          }
        })
        .catch((error) => {
          this.loadingWarehouses = false;
          if (error.message) {
            this.$notify.error(error)
          } else {
            this.$notify.textError("Houve um erro ao buscar os armazéns");
          }
        });
      },

      getItemReduzidoFromRef(ref) {
        return shared.getItemReduzidoFromRef(ref);
      },

      alwaysTrueFilterPredicate() {
        return true;
      },

      tabChangedToWarehouses() {
        this.tabChanged(TAB_INDEXES.WAREHOUSES);

        this.$nextTick(() => {
          this.$refs.itemWarehousesTab.tabChanged();
        });
      },

      tabChangedToLocations() {
        this.tabChanged(TAB_INDEXES.LOCATIONS);

        this.$nextTick(() => {
          this.$refs.itemLocationsTab.tabChanged();
        });
      },

      tabChangedToLots() {
        this.tabChanged(TAB_INDEXES.LOTS);

        this.$nextTick(() => {
          this.$refs.itemLotsTab.tabChanged();
        });
      },

      tabChangedToBalances() {
        this.tabChanged(TAB_INDEXES.BALANCES);

        this.$nextTick(() => {
          this.$refs.itemBalancesTab.tabChanged();
        });
      },

      tabChangedToHistory() {
        this.tabChanged(TAB_INDEXES.HISTORY);

        this.$nextTick(() => {
          this.$refs.itemMovementsTab.tabChanged();
        });
      },

      tabChangedToComposition() {
        this.tabChanged(TAB_INDEXES.COMPOSITION);

        this.$nextTick(() => {
          this.$refs.itemCompositionTab.tabChanged();
        });
      },

      tabChanged(index) {
        this.tabIndex = index;
        localStorage.setItem('item-show-active-tab', index);

        if (!this.warehousesSearched) {
          this.getWarehouses();
          this.warehousesSearched = true;
        }
      },

      setIsUserManager() {
        if (
          this.authUser &&
          this.authUser.profile &&
          this.authUser.profile.modules
        ) {
          let itemsProfileModule = this.authUser.profile.modules.find(
            (pm) => {
              return (
                pm.name && pm.name.toString().toUpperCase() == "ITEMS"
              );
            }
          );

          this.isUserManager =
            itemsProfileModule && itemsProfileModule.canWrite;
        }
      },

      getEmpresaCodigoFromRef(ref) {
        return shared.getEmpresaCodigoFromRef(ref);
      },

      updateItem(newItem) {
        this.item = {};

        if (this.isModal) {
          this.saveModalScrollPosition();
        }

        this.$nextTick(() => {
          this.item = newItem;

          if (this.isModal) {
            this.$nextTick(() => {
              this.restoreModalScrollPosition();
            });
          }
        });
      },

      locationsSearchedCallback(locations) {
        if (!this.locationsFilter.locations || !this.locationsFilter.locations.length) {
          this.locationsFilter.locations = JSON.parse(JSON.stringify(locations));

          if (this.locationsFilter.locations) {
            this.locationsFilter.locations.unshift({id: null, name: 'Todas'});
          }
        }
      },

      lotsSearchedCallback(lots) {
        if (!this.lotsFilter.lots || !this.lotsFilter.lots.length) {
          this.lotsFilter.lots = JSON.parse(JSON.stringify(lots));

          if (this.lotsFilter.lots) {
            this.lotsFilter.lots.unshift({id: null, lotNumber: 'Todos'});
          }
        }
      },

      searchLots(searchText) {
        if (!this.lotsFilter.loading && searchText && searchText.length) {
          if (this.lotSearchTimeout) {
            clearTimeout(this.lotSearchTimeout);
          }

          this.lotSearchTimeout = setTimeout(() => {
            this.lotsFilter.loading = true

            let conditions = [{
              field: 'item.id',
              conditionalOperator: 'EQUALS',
              value: this.item.id
            }];

            if (searchText && searchText.length) {
              conditions.push({
                field: 'lotNumber',
                conditionalOperator: 'LIKE_START',
                value: searchText
              });
            }

            httpClient
            .post(`${process.env.VUE_APP_API_URL}item-lots/condition?page=${0}&size=${10}&sort=createdAt,asc`, {
              conditions: conditions
            })
            .then(({ data }) => {
              this.lotsFilter.lots = data.data.content

              if (this.lotsFilter.lots) {
                this.lotsFilter.lots.unshift({id: null, lotNumber: 'Todos'});
              }

              this.lotsFilter.loading = false
            })
            .catch((error) => {
              if (error.message) {
                this.$notify.error(error)
              }
              this.lotsFilter.lots = [];
              this.lotsFilter.loading = false
            });
          }, 500);
        }
      },

      searchLocations(searchText, addConditions) {
        if (!this.locationsFilter.loading && searchText && searchText.length) {
          if (this.locationSearchTimeout) {
            clearTimeout(this.locationSearchTimeout);
          }

          this.locationSearchTimeout = setTimeout(() => {
            this.locationsFilter.loading = true

            let conditions = [{
              logicalOperator: 'OR',
              conditions: [
                {
                  joinType: 'LEFT',
                  field: 'item.id',
                  value: this.item.id
                },
                {
                  joinType: 'LEFT',
                  field: 'balances.itemLot.item.id',
                  value: this.item.id
                }
              ]
            }];

            if (addConditions) {
              conditions = addConditions(conditions);
            }

            if (searchText && searchText.length) {
              conditions.push({
                field: 'name',
                conditionalOperator: 'LIKE_START',
                value: searchText
              });
            }

            httpClient
            .post(`${process.env.VUE_APP_API_URL}locations/condition?page=${0}&size=${10}`, {
              conditions: conditions,
              distinct: true
            })
            .then(({ data }) => {
              this.locationsFilter.locations = data.data.content;

              if (this.locationsFilter.locations) {
                this.locationsFilter.locations.unshift({id: null, name: 'Todos'});
              }

              this.locationsFilter.loading = false;
            })
            .catch((error) => {
              if (error.message) {
                this.$notify.error(error)
              }
              this.locationsFilter.locations = [];
              this.locationsFilter.loading = false
            });
          }, 500);
        }
      },

      listenToScrollBottom() {
        this.scrollableElement = window;

        if (this.isModal) {
          let modal = document.getElementById('item-details-modal');

          if (modal) {
            let modalBody = modal.querySelector('.modal-body');

            if (modalBody) {
              this.scrollableElement = modalBody;
            }
          }
        }

        this.scrollableElement.addEventListener('scroll', this.onScroll);
      },

      onScroll() {
        if (
          this.currentTab &&
          this.currentTab.onScrollBottom &&
          auth.isScrollOnBottom(this.isModal ? this.scrollableElement : undefined)
        ) {
          this.currentTab.onScrollBottom();
        }
      },

      saveModalScrollPosition() {
        if (!this.scrollableElement) {
          return;
        }

        shared.setLocalStorageString(
          'item-details-modal/scrollPosition',
          this.scrollableElement.scrollTop
        );
      },

      restoreModalScrollPosition() {
        if (!this.scrollableElement) {
          return;
        }

        const scrollPosition = shared.getLocalStorageString('item-details-modal/scrollPosition');

        if (scrollPosition !== null && scrollPosition !== undefined) {
          this.scrollableElement.scrollTop = parseInt(scrollPosition);
        }
      }
    }
  }
</script>

<style>
  .information-item {
    padding: 0.4rem;
    margin-bottom: 1em;
    background-color: rgba(220, 220, 220, 0.2);
    border-top: 3px solid #1fb7cc;
    border-top-left-radius: .20rem;
    border-top-right-radius: .20rem;
    box-shadow: 0px 3px 5px 0 rgba(0,0,0,0.3);
  }

  .dropdown-menu form {
    width: 410px;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  @media (max-width: 575px) {
    .dropdown-menu form {
      width: 290px;
    }
  }
</style>
